import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { Pagination } from '../../../clases/Pagination';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'pagination',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule
  ],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss'
})
export class PaginationComponent {

  @Input() pagination!: Pagination;
  @Input() dataSource!: Function;
  
  get totalPages(): number {
    return Math.max(1, Math.ceil(this.pagination.totalRecords / Math.max(1, this.pagination.pageSize)));
  }

  updateDataSource = ()=>{
    this.dataSource(this.updatePagination);
  }

  updatePagination = (total: number)=>{
    this.pagination.totalRecords = total;
    this.pagination.pageInput = this.pagination.currentPage;
    this.updateVisiblePages();
  }

  private updateVisiblePages = ()=> {
    const total = this.totalPages;
    const cur = Math.min(Math.max(1, this.pagination.currentPage), total);
    let start = Math.max(1, cur - 2);
    let end = Math.min(total, start + 4);
    // ensure 5 buttons when possible
    start = Math.max(1, end - 4);
    const pages: number[] = [];
    for (let p = start; p <= end; p++) pages.push(p);
    this.pagination.visiblePages = pages;
  }

  goToPage(p: number | string | null | undefined) {
    const num = Math.max(1, Math.min(this.totalPages, Number(p) || 1));
    if (num === this.pagination.currentPage) return;
    this.pagination.currentPage = num;
    this.pagination.pageInput = num;
    this.updateDataSource();
  }

  prevPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.pagination.pageInput = this.pagination.currentPage;
      this.updateDataSource();
    }
  }

  nextPage() {
    if (this.pagination.currentPage < this.totalPages) {
      this.pagination.currentPage++;
      this.pagination.pageInput = this.pagination.currentPage;
      this.updateDataSource();
    }
  }

  onPageSizeChange() {
    this.pagination.pageSize = Math.max(1, Math.floor(Number(this.pagination.pageSize) || 10));
    this.pagination.currentPage = 1;
    this.pagination.pageInput = 1;
    this.updateDataSource();
  }
    
}
